export const fileUrl = (
  id: string | number | undefined,
  token: string | undefined,
) =>
  `${process.env.REACT_APP_API_URL}/v1/Document/${id}/Download?access_token=${token}`;

export const documentUrl = (id: string | number | undefined) =>
  `${process.env.REACT_APP_API_URL}/v1/Document/${id}`;
